import { IDanhSachTotNghiepActionTypes } from "../../action-types/xet-tot-nghiep/IDanhSachTotNghiepActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDanhSachTotNghiepReducer } from "../../reducer-model/xet-tot-nghiep/IDanhSachTotNghiepReducer";

const iniState: IDanhSachTotNghiepReducer = {
    status: eReducerStatusBase.is_not_initialization,
    danhSachTotNghieps: [],
}

export const danhSachTotNghiepReducer = (state: IDanhSachTotNghiepReducer = iniState, action: IDanhSachTotNghiepActionTypes): IDanhSachTotNghiepReducer => {
    switch (action.type) {
        case "DANH_SACH_TOT_NGHIEP_LOAD_BY_DOT_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DANH_SACH_TOT_NGHIEP_LOAD_BY_DOT_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                danhSachTotNghieps: action.payload,
            };
        case "DANH_SACH_TOT_NGHIEP_LOAD_BY_DOT_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DANH_SACH_TOT_NGHIEP_UPDATE_TRANG_THAI_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DANH_SACH_TOT_NGHIEP_UPDATE_TRANG_THAI_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DANH_SACH_TOT_NGHIEP_UPDATE_TRANG_THAI_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DANH_SACH_TOT_NGHIEP_UPDATE_QUYET_DINH_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DANH_SACH_TOT_NGHIEP_UPDATE_QUYET_DINH_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DANH_SACH_TOT_NGHIEP_UPDATE_QUYET_DINH_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DANH_SACH_TOT_NGHIEP_UPDATE_SO_HIEU_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DANH_SACH_TOT_NGHIEP_UPDATE_SO_HIEU_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DANH_SACH_TOT_NGHIEP_UPDATE_SO_HIEU_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DANH_SACH_TOT_NGHIEP_UPDATE_SO_VAO_SO_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DANH_SACH_TOT_NGHIEP_UPDATE_SO_VAO_SO_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DANH_SACH_TOT_NGHIEP_UPDATE_SO_VAO_SO_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };

        case "DANH_SACH_TOT_NGHIEP_HUY_KET_QUA_XET_TOT_NGHIEP_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DANH_SACH_TOT_NGHIEP_HUY_KET_QUA_XET_TOT_NGHIEP_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DANH_SACH_TOT_NGHIEP_HUY_KET_QUA_XET_TOT_NGHIEP_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DANH_SACH_TOT_NGHIEP_UPDATE_SO_IN_QUYET_DINH_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DANH_SACH_TOT_NGHIEP_UPDATE_SO_IN_QUYET_DINH_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DANH_SACH_TOT_NGHIEP_UPDATE_SO_IN_QUYET_DINH_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}